module.exports = __webpack_public_path__ + "img/IE.cff1f385.png";